/** 시설별 경광등 제어 API — 백엔드 DEFAULT_POOL_SIREN_API_CONFIG 와 동기 */

export type PoolSirenProtocol = 'tcp' | 'http';

export type PoolSirenHttpMethod = 'GET' | 'POST';

export interface PoolSirenApiConfig {
  protocol: PoolSirenProtocol;
  default_port: number;
  socket_timeout_sec: number;
  tcp_append_newline: boolean;
  tcp_command_start_danger: string;
  tcp_command_start_warning: string;
  tcp_command_stop: string;
  http_method: PoolSirenHttpMethod;
  http_start_path_danger: string;
  http_start_path_warning: string;
  http_stop_path: string;
}

export const DEFAULT_POOL_SIREN_API_CONFIG: PoolSirenApiConfig = {
  protocol: 'tcp',
  default_port: 5000,
  socket_timeout_sec: 2,
  tcp_append_newline: false,
  tcp_command_start_danger: 'hex:00 f1 ff',
  tcp_command_start_warning: 'hex:00 f1 ff',
  tcp_command_stop: 'hex:00 01 ff',
  http_method: 'GET',
  http_start_path_danger: '',
  http_start_path_warning: '',
  http_stop_path: '',
};

export function mergePoolSirenApiConfig(
  raw: Partial<PoolSirenApiConfig> | null | undefined
): PoolSirenApiConfig {
  const base = { ...DEFAULT_POOL_SIREN_API_CONFIG, ...(raw || {}) };
  const protocol = base.protocol === 'http' ? 'http' : 'tcp';
  const httpMethod = base.http_method === 'POST' ? 'POST' : 'GET';
  return {
    ...base,
    protocol,
    http_method: httpMethod,
    default_port: Number.isFinite(Number(base.default_port))
      ? Number(base.default_port)
      : DEFAULT_POOL_SIREN_API_CONFIG.default_port,
    socket_timeout_sec: Number.isFinite(Number(base.socket_timeout_sec))
      ? Number(base.socket_timeout_sec)
      : DEFAULT_POOL_SIREN_API_CONFIG.socket_timeout_sec,
    tcp_append_newline: Boolean(base.tcp_append_newline),
  };
}
